import { DialogTitle } from '@aibees/shared/components';
import { SubscriptionModalType } from '@aibees/shared/features';
import { usePlanCardContext } from '@aibees/shared/features/plan-card/context';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames, fHumanReadableNumber } from '@aibees/shared/utils';
import { DialogContent, Stack, Typography } from '@mui/material';
import { memo, useEffect } from 'react';
import { DialogFooter } from './components/dialog-footer';
import { DowngradeInformation } from './components/downgrade-information';
import * as Styled from './styles';
import * as SX from './sx';
import type { DowngradeConfirmationDialogProps as Props } from './types';

export const DowngradeConfirmationDialog = memo(
  ({ className, activeModal, closeModal, onCancel, onConfirm }: Props) => {
    const state = useBoolean(false);

    useEffect(() => {
      state.setValue(activeModal === SubscriptionModalType.CONFIRM_MODAL);
    }, [activeModal, state]);

    const { data } = useCurrentSubscriptionApi();
    const { selectedPlan, yearly } = usePlanCardContext();
    const currentPlan = data?.current?.plan;

    const isDowngradingToFree = selectedPlan?.metadata.is_free === 'true';

    const isDowngradingToLowerPaid =
      !isDowngradingToFree &&
      (currentPlan?.interval === selectedPlan?.interval ||
        (currentPlan?.interval === 'MONTH' &&
          selectedPlan?.interval === 'YEAR')) &&
      Number(currentPlan?.metadata.request) >
        Number(selectedPlan?.metadata.request);

    return (
      <Styled.Wrapper
        open={state.value}
        onClose={closeModal}
        className={classnames('DowngradeConfirmationDialog', className)}
        sx={SX.root}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          title="You May Lose Credits on Downgrade"
          onClose={closeModal}
        />
        <DialogContent>
          <Stack gap={1}>
            <Typography variant="body3" color="grey.900" fontWeight={700}>
              {isDowngradingToLowerPaid ? (
                'Are you sure you want to Downgrade?'
              ) : (
                <>
                  Are you sure you want to cancel the{' '}
                  {fHumanReadableNumber(
                    Number(data?.current?.plan?.metadata.request)
                  )}{' '}
                  Credit/{yearly ? 'Yearly' : 'Monthly'} Plan?{' '}
                </>
              )}
            </Typography>
            <DowngradeInformation />
          </Stack>
        </DialogContent>
        <DialogFooter
          closeModal={closeModal}
          onCancel={onCancel}
          onConfirm={onConfirm}
        />
      </Styled.Wrapper>
    );
  }
);

DowngradeConfirmationDialog.displayName = 'DowngradeConfirmationDialog';
